import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './AlbumHeader.css'
import Icon from '../Icon'
import { pluralize } from '../../utils/string'

export default class AlbumHeader extends Component {
  coverSrc = this.props.getImageSource(this.props.cover, 'd')
  componentWillReceiveProps (nextProps) {
    if (this.props.cover !== nextProps.cover) {
      this.coverSrc = this.props.getImageSource(nextProps.cover, 'd')
    }
  }
  render () {
    const { id, title, task, setFavouriteAlbum, hasFavourited, anonymousUser, isOwnAlbum, owner, isFixed } = this.props
    const iconClassNames = {
      info: task === 'info' ? classNames.active : null,
      edit: task === 'edit' ? classNames.active : null,
      favourite: hasFavourited ? classNames.active : null
    }
    const paths = {
      info: task === 'info' ? `/album/${id}` : `/album/${id}/info`,
      edit: task === 'edit' ? `/album/${id}` : `/album/${id}/edit`
    }
    const gradient = 'linear-gradient(180deg, rgba(0,0,0,0.4) 70%, rgba(0,0,0,0.8) 100%)'
    const style = {
      backgroundImage: this.coverSrc && `${gradient}, url(${this.coverSrc})`
    }
    return (
      <header className={classNames.header} style={style}>
        <h2 className={classNames.title}>
          {title}
          {/*
          {!isOwnAlbum && owner &&
            <span className={classNames.shareInfo}>
              Shared by {owner.name}
            </span>
          }
          {isFixed &&
            [
              <Icon key={0} className={classNames.fixedIcon} icon='lock' size={18} />,
              <span key={1} className={classNames.fixedTitle}>Fixed Album</span>
            ]
          }
          */}
        </h2>
        <div className={classNames.subtitle}>
          {!this.props.hideCount && (this.props.count === 0 || this.props.count ? pluralize(this.props.count, 'image') : 'Loading…')}
          {!isOwnAlbum && owner ? ` · Shared by ${owner.name}` : ''}
          {isFixed &&
            <span style={{ marginLeft: '20px' }}>
              <Icon icon='lock' size={13} style={{ marginRight: '3px' }} /> Locked
            </span>
          }
        </div>
        <div className={classNames.bottomLeft}>
          {this.props.canEdit &&
            <Link to={paths.edit} className={classNames.iconButton}>
              <Icon icon='edit' className={iconClassNames.edit} size={20} />
            </Link>
          }
          {id && !anonymousUser &&
            <button
              onClick={() => setFavouriteAlbum(id, !hasFavourited)}
              className={classNames.iconButton}
              style={{ marginRight: '2px' }}>
              <Icon icon={hasFavourited ? 'heart' : 'heart-outline'} size={24} className={iconClassNames.favourite} />
            </button>
          }
        </div>
        <div className={classNames.bottomRight}>
          <input
            className={classNames.slider}
            type='range'
            min={80}
            max={640}
            defaultValue={this.props.thumbSize}
            onMouseUp={e => this.props.updateThumbSize(parseInt(e.target.value))}
          />
          {this.props.renderMenuToggle(classNames.iconButton)}
          {id && !anonymousUser &&
            <Link to={paths.info} className={classNames.infoButton}>
              <Icon icon='info' className={iconClassNames.info} size={28} />
            </Link>
          }
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/album/AlbumHeader.js